import * as TYPE from './actionType.js';

export function pageData(pageData) {
  return { type: TYPE.PAGEDATA, data: pageData };
}
